export enum ProductID {
  MembershipWithRoadsideAssistance = '1111',
  Membership = '1121',
  Young = '1131',
  YoungWithRoadsideAssistance = '1141',
  ChargingTag = '8004',
  Idp1Year = '8002',
  Idp3Year = '8003',
  Idp1and3Year = '8002-8003',
  RoadSideAssistance = '2020',
  MC = '1601',
  MCRoadSideAssistance = '2070', // This is the RA package for MC.
  MCWithRoadsideAssistance = '1605',
  TrialMembership = '6111',
  TrialMembershipWithRoadsideAssistance = '6020',
}
